import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { buildDrupalImage } from '../Image';
import { ParagraphOptions } from './AllParagraphs';

export const mapNewsTeaser = (
  input: NewsTeaserFragment,
  context: { payload?: ParagraphOptions },
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'Teaser'> => {
  const news = input.newsContent!;

  return {
    key: 'Teaser',
    input: {
      teaser: {
        title: news.title,
        Description: undefined,
        Link: buildLink({ href: news.path }),
        date: news.date,
        Image: news.teaserImage
          ? buildDrupalImage(
              news.teaserImage,
              context.payload?.inSidebar ? 'teaser' : 'content',
            )
          : undefined,
        isFullWidth: !context.payload?.inSidebar,
        arrowIsVisible: true,
      },
      inSidebar: !!context.payload?.inSidebar,
    },
  };
};
